export default {
	namespaced: true,
	state: { telaAtualErros: {} },
	mutations: {
		resetErrors(state){
			state.telaAtualErros = {};
		},
		setTelaAtualErros(state, erros){
			state.telaAtualErros = erros;
		},
	},
	getters: {
		getErrorByField: (state) => (campo, customErrors = []) => {
			if(!state.telaAtualErros[campo]){
				return [...customErrors];
			}
			return [...state.telaAtualErros[campo], ...customErrors];
		},
		getErrorMessagesByField: (state) => (campo) => {
			if(!state.telaAtualErros[campo]){
				return [];
			}
			return state.telaAtualErros[campo].map((item) => item);
		},
	},
};
